export default __webpack_public_path__ + "assets/71f143225dae433cdbc28e952da9d842.woff2";